export type ConversationSurface = 'chat' | 'quick'
export type ConversationScope = {surface: ConversationSurface; id: string | null}

const QUICK_CHAT_PREFIX = '/copilot/quick-chats'

export function getQuickChatScope(pathname: string): ConversationScope | undefined {
  const normalized = pathname.replace(/\/+$/, '') || '/'
  if (normalized === QUICK_CHAT_PREFIX) return {surface: 'quick', id: null}
  if (!normalized.startsWith(`${QUICK_CHAT_PREFIX}/`)) return undefined

  const encodedTaskId = normalized.slice(QUICK_CHAT_PREFIX.length + 1)
  // Only the registered collection and single-task routes represent quick chats.
  if (encodedTaskId === '' || encodedTaskId.includes('/')) return undefined

  let taskId: string
  try {
    taskId = decodeURIComponent(encodedTaskId)
  } catch {
    // Match react-router's param decoding, which returns the raw segment for a
    // malformed percent-encoding rather than throwing.
    taskId = encodedTaskId
  }
  return {surface: 'quick', id: taskId}
}

export function shouldEnableV1CitationMarkerSanitization(scope: ConversationScope | undefined): boolean {
  return scope?.surface !== 'quick'
}

export function shouldResetForScopeChange(
  previousScope: ConversationScope | undefined,
  nextScope: ConversationScope,
): boolean {
  if (previousScope === undefined) return false
  if (previousScope.surface !== nextScope.surface) return true
  return previousScope.id !== null && previousScope.id !== nextScope.id
}
